import NewUserForm from './NewUserForm';

export default NewUserForm;
